// Utility function for checking win conditions in Caro game
// This ensures consistent win detection across all game modes

export const checkCaroWin = (board, row, col, player, winCondition = 5) => {
  const boardRows = board.length;
  const boardCols = board[0] ? board[0].length : 0;
  
  // Validate inputs
  if (row < 0 || row >= boardRows || col < 0 || col >= boardCols) {
    return null;
  }
  
  if (board[row][col] !== player) {
    return null;
  }

  const directions = [
    [0, 1],   // horizontal
    [1, 0],   // vertical  
    [1, 1],   // diagonal \
    [1, -1]   // diagonal /
  ];

  for (const [dx, dy] of directions) {
    let count = 1;
    const winningLine = [[row, col]];

    // Check positive direction
    let r = row + dx;
    let c = col + dy;
    while (r >= 0 && r < boardRows && c >= 0 && c < boardCols && board[r][c] === player) {
      winningLine.push([r, c]);
      count++;
      r += dx;
      c += dy;
    }

    // Check negative direction  
    r = row - dx;
    c = col - dy;
    while (r >= 0 && r < boardRows && c >= 0 && c < boardCols && board[r][c] === player) {
      winningLine.unshift([r, c]);
      count++;
      r -= dx;
      c -= dy;
    }

    // Check if we have enough consecutive pieces
    if (count >= winCondition) {
      return {
        winner: player,
        winningLine: winningLine,
        direction: [dx, dy],
        count: count
      };
    }
  }

  return null;
};

// Check if board is full (for draw detection)
export const isBoardFull = (board) => {
  return board.every(row => row.every(cell => cell !== null));
};

// Get game status after a move
export const getGameStatus = (board, row, col, player, winCondition = 5) => {
  // Check for win
  const winResult = checkCaroWin(board, row, col, player, winCondition);
  if (winResult) {
    return {
      isGameOver: true,
      winner: winResult.winner,
      winningLine: winResult.winningLine,
      reason: 'win'
    };
  }

  // Check for draw
  if (isBoardFull(board)) {
    return {
      isGameOver: true,
      winner: null,
      winningLine: null,
      reason: 'draw'
    };
  }

  // Game continues
  return {
    isGameOver: false,
    winner: null,
    winningLine: null,
    reason: null
  };
};
